<template>
  <md-layout md-column>
    <span class="md-title">REGISTRO DE FOTOS</span>
    <span class="md-caption">Nesta etapa você precisa adicionar as fotos dos <i>vertices</i> e <i>equipamentos</i> de cada ÁREA definida.</span>
    <p class="md-caption"
            >*<b>Vértices</b> são as quatro (4) quinas de cada instalação cadastrada, detalhando o ambiente como um todo.<br /></p
          >
    <md-list v-if="certificationProcess">
      <md-list-item v-for="area in certificationProcess.areas" :key="area['.key']">
        <md-icon v-if="area.status===0 || !area.status" class="md-warn">warning</md-icon>
        <md-icon v-else class="done">done_all</md-icon>
        <span>Área: {{area.name}}</span>
        <span class="caption">{{area.description}}</span>
        <md-divider></md-divider>
        <!-- <md-list-expand>
          <md-list>
            <md-list-item v-for="item in area.structures" :key="item['.key']" >
              <md-icon class="done" v-if="item.status ===1">done</md-icon>
              <md-icon v-else>add_a_photo</md-icon>
              <span>{{item.name}}</span>
            </md-list-item>
          </md-list>
          <md-list>
            <md-list-item v-for="item in area.vertices" :key="item['.key']">
              <md-icon class="done" v-if="item.status ===1">done</md-icon>
              <md-icon v-else>add_a_photo</md-icon>
              <span>{{item.name}}</span>
            </md-list-item>
          </md-list>
        </md-list-expand> -->
      </md-list-item>
    </md-list>
    <md-layout md-row md-flex md-gutter>
      <md-layout md-column>
        <md-button class="md-accent md-raised" @click="openPhotos()">FOTOS INSTALAÇÕES/EQUIPAMENTOS</md-button>
      </md-layout>
      <md-layout md-column v-if="certificationProcess.status > 4">
        <md-button class="md-primary md-raised" @click="finishPhotos()">Próxima Etapa</md-button>
      </md-layout>
    </md-layout>
  </md-layout>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'photos-list',
  computed: {
    ...mapState({
      'certificationProcess': state => state.certificationProcess
    })
  },
  beforeMount () {
    this.FETCH_DATA()
  },
  methods: {
    ...mapActions([
      'FETCH_DATA',
      'GOTO_STEP'
    ]),
    openPhotos () {
      this.$router.push('/photos')
    },
    finishPhotos () {
      this.GOTO_STEP(2)
    }
  }
}
</script>
<style scoped>
.done {
  color: #3ccb70
}
</style>



// WEBPACK FOOTER //
// PhotosList.vue?51683565